<div class="task-filters-header">
    <pf-text type="subtitle">Filters:</pf-text>
    <pf-button buttonType="clear" (click)="clearFilters()"
        >Clear filters</pf-button
    >
</div>
<div class="task-filters">
    <ng-content></ng-content>
</div>
